import { render, staticRenderFns } from "./PatientAddress.vue?vue&type=template&id=1c4c0568&scoped=true&"
import script from "./PatientAddress.vue?vue&type=script&lang=js&"
export * from "./PatientAddress.vue?vue&type=script&lang=js&"
import style0 from "./PatientAddress.vue?vue&type=style&index=0&id=1c4c0568&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4c0568",
  null
  
)

export default component.exports